import type { FC } from 'react';

import { HelpText } from '../../../../services/helpTranslations/reactBindings/HelpText';

export const HelpChapterCrashGameInconveniences: FC = () => {
  return (
    <div>
      <p>
        <HelpText tk="gameInconveniencesWithoutCashout50.gameError" />
      </p>
      <p>
        <HelpText tk="gameInconveniencesWithoutCashout50.cashoutAction" />
      </p>
      <p>
        <HelpText tk="gameInconveniencesWithoutCashout50.errorGameID" markdown />
      </p>
    </div>
  );
};
